import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'pl-product-popup-table',
  templateUrl: './pl-product-popup-table.component.html',
  styleUrls: ['./pl-product-popup-table.component.css']
})
export class PlProductPopupTableComponent implements OnInit {
  HideOfferName: any;
  PortalHodeOffer: any;
  @Input() offer;
  OfferName:string='Offer';
  
  constructor() { }

  ngOnInit() {
    let PortalInfoData=localStorage.getItem('portalInfo');
    if(PortalInfoData){
      this.PortalHodeOffer=JSON.parse(PortalInfoData);
      this.HideOfferName=this.PortalHodeOffer.hideoffername;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/loan/lead-popup-product-info/pl-product-popup-table/pl-product-popup-table.component.ts